import { render } from "./ViewPaiement.vue?vue&type=template&id=53d113b1&ts=true"
import script from "./ViewPaiement.vue?vue&type=script&lang=ts"
export * from "./ViewPaiement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__